module.exports = __webpack_public_path__ + "static/bank-tablet-app-cover-36d95d7d3bee80bb990d57b8957dd0de.png";